.chatContainer {
    width: 100%;
    height: 100%;
    padding: var(--mantine-spacing-xl);
    margin-top: 10rem;
    view-transition-name: dashboard;

    @container (min-width: 28em) {
        margin-left: 10rem;
        margin-right: 10rem;
    }

    /** Responsive margin from top */
    @container (min-width: $mantine-breakpoint-sm) {
        margin-top: clamp(5rem, 25vh, 25rem);
        justify-content: flex-start;
    }
}

.frontPageContainer {
    max-width: calc(64rem * var(--mantine-scale));
    margin: 0 auto;
    width: 100%;
}

.textarea {
    border: none;
}

.textareaWrapper {
    flex: 1;
}

.sendButton {
    color: lighten(var(--dib-brand-base), 0.5);
    border-radius: var(--mantine-radius-xl);
    margin: "auto";
    transition: background-color 0.1s ease-in-out;
    width: 25px;
    height: 25px;
    min-width: 25px;
    min-height: 25px;
    padding: 0;
    @container (min-width: $mantine-breakpoint-sm) {
        width: 31px;
        height: 31px;
        min-width: 31px;
        min-height: 31px;
    }

    &:hover {
        color: var(--dib-brand-base);
        background-color: rgba(255, 255, 255);
    }
}

.sendButtonInner {
}

.hiddenText {
    position: absolute;
    visibility: hidden;
    white-space: pre-wrap;
    font-family: Lato;
    font-size: var(--mantine-font-size-sm);
    @container (min-width: $mantine-breakpoint-sm) {
        font-size: var(--mantine-font-size-xl);
    }
}
.textareaInput {
    width: 100%;
    will-change: height;
    flex: 1;
    border: none;
    background-color: transparent;
    font-size: var(--mantine-font-size-sm);
    padding-left: 1px;
    @container (min-width: $mantine-breakpoint-sm) {
        padding: 0;
        height: var(--mantine-spacing-xl);
        font-size: var(--mantine-font-size-xl);
    }
}

.textareaInput::placeholder {
    color: lighten(var(--dib-brand-base), 0.5);
}

.buttonGroup {
    justify-content: space-between;
    flex-wrap: nowrap;
    gap: var(--mantine-spacing-xs);
}
